import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import SectionTitle from "../../../components/SectionTitle";
import { Box, Hidden } from "@mui/material";
import AboutRecipeImage from "../../../images/AboutRecipeImage.svg";
import styles from "./css/AboutGarudaRecipeCard.module.css";
import { ExploreMoreButton } from "../../../components/ExploreMoreButton/ExploreMoreButton";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../routes/routes";

export default function AboutGarudaRecipe() {
  const navigate = useNavigate();

  const handleExploreMore = () => {
    navigate(Routes.ABOUT_RECIPE);
  };

  return (
    <Box className={styles.aboutGarudaRecipeCard}>
      <Hidden mdDown>
        <img src={AboutRecipeImage} alt={"More about Garuda Recipe"}></img>
      </Hidden>
      <Box className={styles.cardContentContainer}>
        <CardContent className={styles.cardContent}>
          <SectionTitle
            dataTestId="garuda-recipe"
            value="Discover the Power of Recipes"
            config={{
              marginBottom: "5%",
            }}
          />
          <Typography data-testid="garuda-recipe-desc" variant="body1">
            Transform how you work with agents—build pipelines, automate
            workflows, and achieve more with less effort. Start creating your
            first Recipe today!
          </Typography>
        </CardContent>
        <CardActions>
          <ExploreMoreButton
            label="Explore Now"
            dataTestId="garuda-recipe-btn"
            clickHandler={handleExploreMore}
          />
        </CardActions>
      </Box>
    </Box>
  );
}
